import React, { ReactNode, useMemo } from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import { Config } from '@surglogs-app/types'

import { useReCaptchaToken } from '../hooks/useReCaptchaToken'

interface ReCaptchaProviderProps {
  children: ReactNode
  config: Pick<Config, 'reCaptchaKey'>
}

export const AccountSettingsRecaptchaProvider = ({
  children,
  config,
}: ReCaptchaProviderProps) => {
  const [, reCaptchaKey = ''] = useReCaptchaToken({ config })

  const scriptProps = useMemo(() => ({ async: true }), [])

  const container = useMemo(
    () =>
      ({
        element: 'recaptcha-container',
        parameters: {
          badge: 'bottomright',
        },
      } as const),
    [],
  )

  return (
    <GoogleReCaptchaProvider
      {...{
        reCaptchaKey,
        scriptProps,
        container,
      }}>
      {children}
    </GoogleReCaptchaProvider>
  )
}
